// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3EMzy","title":"FrontImage_title__3PE58"};